import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./Auth";
import { ExamsProvider } from "./Exams";
import { GroupsProvider } from "./Groups";
import { HospitalsProvider } from "./Hospitals";
import { PartnersProvider } from "./Partners";
import { RegisterProvider } from "./Register";
import { UsersProvider } from "./Users";
import type { ReactNode } from "react";
import { AdditionRequestProvider } from "./AdditionRequest";

interface IAppProvider {
  children: ReactNode;
}

export const AppProvider = ({ children }: IAppProvider) => {
  return (
    <RegisterProvider>
      <AuthProvider>
        <UsersProvider>
          <HospitalsProvider>
            <PartnersProvider>
              <ExamsProvider>
                <AdditionRequestProvider>
                  <GroupsProvider>{children}</GroupsProvider>
                </AdditionRequestProvider>
                <ToastContainer />
              </ExamsProvider>
            </PartnersProvider>
          </HospitalsProvider>
        </UsersProvider>
      </AuthProvider>
    </RegisterProvider>
  );
};
